// extracted by mini-css-extract-plugin
export default {"tabs":"CertificateTabs_tabs__pwN5W"};